import { StructuredData } from '@/components/seo/StructuredData';
import { BLOG_ID, blogPostSchemas } from '@/lib/blogSchema';
import { getPublishedPosts, type BlogPostMeta } from '@/lib/blog';

interface BlogListStructuredDataProps {
  url: string;
  posts?: BlogPostMeta[];
  /** Set on a category page: adds the category after Home › Blog in the breadcrumb. */
  categoryName?: string;
}

export function BlogListStructuredData({ url, posts = getPublishedPosts(), categoryName }: BlogListStructuredDataProps) {
  const crumbs = [
    { name: 'Home', item: 'https://beatview.ai' },
    { name: 'Blog', item: 'https://beatview.ai/blog' },
    ...(categoryName ? [{ name: categoryName, item: url }] : []),
  ];
  return (
    <StructuredData
      data={[{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Beatview Blog',
        description: 'Practical guides for recruitment agencies on candidate screening, structured and AI interviews, recruiting metrics and responsible AI in hiring.',
        url,
        publisher: { '@type': 'Organization', '@id': 'https://beatview.ai/#organization', name: 'Beatview', url: 'https://beatview.ai' },
        mainEntity: {
          '@type': 'Blog',
          '@id': BLOG_ID,
          name: 'Beatview Blog',
          blogPost: posts.map(p => ({ '@type': 'BlogPosting', headline: p.title, url: `https://beatview.ai/blog/${p.slug}`, datePublished: p.publishedAt, dateModified: p.updatedAt })),
        },
      }, {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: crumbs.map((c, i) => ({ '@type': 'ListItem', position: i + 1, name: c.name, item: c.item })),
      }]}
    />
  );
}

interface BlogPostStructuredDataProps {
  post: BlogPostMeta;
  wordCount?: number;
}

/** BlogPosting, BreadcrumbList and FAQPage for one post (same graph the crawler renderer emits). */
export function BlogPostStructuredData({ post, wordCount }: BlogPostStructuredDataProps) {
  return <StructuredData data={blogPostSchemas(post, wordCount)} />;
}
